export default __webpack_public_path__ + "images/XK.b9679d2.png";